import { render } from "./priviewImg.vue?vue&type=template&id=55642ed3&scoped=true"
import script from "./priviewImg.vue?vue&type=script&lang=js"
export * from "./priviewImg.vue?vue&type=script&lang=js"

import "./priviewImg.vue?vue&type=style&index=0&id=55642ed3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55642ed3"]])

export default __exports__